import { connect } from 'react-redux'
import _ from 'lodash'
import styles from './index.css'
import { NothingBlock } from '../YCard'

const NoPrivilegedPermission = props => {
  return (
    <NothingBlock
      className={styles.noPermission}
      iconType='ec-block-people'
      text='您目前無使用權限，可請管理者至「小幫手權限管理設定」進行功能新增'
    />
  )
}

const mapStateToProps = state => {
  const privilegedPages = _.get(state, 'page.privilegedPages')
  return { privilegedPages }
}

export default connect(mapStateToProps)(NoPrivilegedPermission)
